









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { toLocaleDatetimeString } from '@/containers/globals/Util';

@Component({
  components: {},
})
export default class UpdateHistoryInfo extends Vue {
  @Prop()
  private updatedBy!: string;
  @Prop()
  private updatedAt!: string;
  @Prop()
  private eventEnd!: string;
  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;
  @Prop({ required: false, default: false })
  private isHoliday!: boolean;

  private get formattedUpdatedAt() {
    return toLocaleDatetimeString(this.updatedAt);
  }
}
